// EmporiumWorld Theme JS V5 - Dynamic Image Swap Update
document.addEventListener('DOMContentLoaded', () => {
  const drawerOverlay = document.getElementById('CartDrawerOverlay');
  const cartDrawer = document.getElementById('CartDrawer');
  const openCartBtns = document.querySelectorAll('.js-open-cart');
  const closeCartBtn = document.getElementById('CartDrawerClose');

  function openCart() {
    if (cartDrawer && drawerOverlay) {
      cartDrawer.classList.add('is-active');
      drawerOverlay.classList.add('is-active');
    }
  }

  function closeCart() {
    if (cartDrawer && drawerOverlay) {
      cartDrawer.classList.remove('is-active');
      drawerOverlay.classList.remove('is-active');
    }
  }

  openCartBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeCart);

  // Offer Countdown Timer Script
  const timerElement = document.getElementById('OfferCountdownTimer');
  if (timerElement) {
    let totalSeconds = 14 * 60 + 52;
    setInterval(() => {
      if (totalSeconds <= 0) {
        totalSeconds = 15 * 60;
      }
      totalSeconds--;
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      timerElement.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }, 1000);
  }

  // Dynamic Variant Selection & Image Swap Logic
  const variantOptionBtns = document.querySelectorAll('.js-variant-option-btn');
  const variantSelectDropdown = document.getElementById('ProductSelectVariants');
  const mainPriceDisplay = document.getElementById('MainProductPrice');
  const comparePriceDisplay = document.getElementById('MainComparePrice');
  const atcBtn = document.getElementById('MainProductATCBtn');
  const mainImage = document.getElementById('MainProductImg');

  function updateVariantUI(variantId, price, comparePrice, available, imgSrc) {
    // Update Price
    if (mainPriceDisplay && price) mainPriceDisplay.textContent = price;

    // Update Compare Price
    if (comparePriceDisplay) {
      if (comparePrice && comparePrice !== '') {
        comparePriceDisplay.textContent = comparePrice;
        comparePriceDisplay.style.display = 'block';
      } else {
        comparePriceDisplay.style.display = 'none';
      }
    }

    // Update ATC Button
    if (atcBtn) {
      atcBtn.dataset.variantId = variantId;
      if (available === 'false' || available === false) {
        atcBtn.textContent = 'Agotado';
        atcBtn.disabled = true;
      } else {
        atcBtn.textContent = 'Obtener Oferta y Descargar Ahora 🚀';
        atcBtn.disabled = false;
      }
    }

    // UPDATE IMAGE DYNAMICALLY
    if (mainImage && imgSrc && imgSrc.trim() !== '') {
      mainImage.style.opacity = '0.3';
      setTimeout(() => {
        mainImage.src = imgSrc;
        mainImage.style.opacity = '1';
      }, 150);
    }
  }

  if (variantOptionBtns.length > 0) {
    variantOptionBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        variantOptionBtns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const variantId = btn.dataset.variantId;
        const price = btn.dataset.variantPrice;
        const comparePrice = btn.dataset.variantComparePrice;
        const available = btn.dataset.variantAvailable;
        const imgSrc = btn.dataset.variantImg;

        if (variantSelectDropdown) variantSelectDropdown.value = variantId;
        updateVariantUI(variantId, price, comparePrice, available, imgSrc);
      });
    });
  }

  if (variantSelectDropdown) {
    variantSelectDropdown.addEventListener('change', () => {
      const selectedOption = variantSelectDropdown.options[variantSelectDropdown.selectedIndex];
      const variantId = selectedOption.value;
      const price = selectedOption.dataset.variantPrice;
      const comparePrice = selectedOption.dataset.variantComparePrice;
      const available = selectedOption.dataset.variantAvailable;
      const imgSrc = selectedOption.dataset.variantImg;

      // Sync button active class
      variantOptionBtns.forEach(b => {
        if (b.dataset.variantId === variantId) b.classList.add('is-selected');
        else b.classList.remove('is-selected');
      });

      updateVariantUI(variantId, price, comparePrice, available, imgSrc);
    });
  }

  // Add to Cart AJAX Handler
  const atcButtons = document.querySelectorAll('.js-ajax-add-to-cart');
  atcButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = btn.dataset.variantId;
      btn.innerText = 'Añadiendo...';

      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(response => response.json())
        .then(data => {
          btn.innerText = '✓ ¡Añadido!';
          btn.style.background = '#10b981';
          btn.style.color = '#fff';
          setTimeout(() => {
            btn.innerText = 'Añadir al Carrito';
            btn.style.background = '';
            btn.style.color = '';
            window.location.href = '/checkout';
          }, 500);
        })
        .catch(error => {
          console.error('Error:', error);
          window.location.href = '/checkout';
        });
      } else {
        setTimeout(() => {
          btn.innerText = '✓ ¡Añadido!';
          setTimeout(() => {
            btn.innerText = 'Añadir al Carrito';
            openCart();
          }, 400);
        }, 300);
      }
    });
  });
});


/* Bundle Option Selection Handler */
function updateBundleSelection(radio) {
  const options = document.querySelectorAll('.nexora-bundle-option');
  options.forEach(option => option.classList.remove('active'));
  radio.closest('.nexora-bundle-option').classList.add('active');
}
